

import {
  SEARCH_EMPLOYEE_REQUEST,
  SEARCH_EMPLOYEE_SUCCESS,
  SEARCH_EMPLOYEE_FAILURE,
  CLEAR_EMPLOYEES,
} from "../actions/SearchEmployeeActions";

const initialState = {
  loading: false,
  employees: [],
  error: null,
};

const searchEmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_EMPLOYEE_REQUEST:
      return { ...state, loading: true, error: null };

    case SEARCH_EMPLOYEE_SUCCESS:
      return { ...state, loading: false, employees: action.payload, error: null };

    case SEARCH_EMPLOYEE_FAILURE:
      return { ...state, loading: false, employees: [], error: action.payload };

    case CLEAR_EMPLOYEES:
      return { ...state, employees: [], error: null };

    default:
      return state;
  }
};

export default searchEmployeeReducer;
